import { AppConfig } from "config";

export const AuthImage = () => {
  return (
    <div className="hidden bg-[#DBB68828] md:block lg:col-span-2 ">
      <div className="flex relative justify-center items-center  my-auto h-screen ">
        <img
          src={AppConfig.APP_AUTH_IMAGE}
          alt="Image"
          className="object-cover absolute size-full items-center "
        />
        <div className="z-10 bg-secondaryColor/30 size-full"></div>
      </div>
    </div>
  );
};
